export class LlpaTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes(params) {
    return this.#http.get('/api/llpa-types', { params });
  }

  async createType(body) {
    return this.#http.post('/api/llpa-types', body);
  }

  async editType({ llpaTypeId, ...body }) {
    return this.#http.put(`/api/llpa-types/${llpaTypeId}`, body);
  }

  async deleteType({ llpaTypeId }) {
    return this.#http.delete(`/api/llpa-types/${llpaTypeId}`);
  }

  async activateType({ llpaTypeId }) {
    return this.#http.put(`/api/llpa-types/${llpaTypeId}/activate`);
  }
}
